import { render, staticRenderFns } from "./KIWFormCard.vue?vue&type=template&id=03c5d629"
import script from "./KIWFormCard.vue?vue&type=script&lang=js"
export * from "./KIWFormCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports